module.exports = __webpack_public_path__ + "img/logo-assynco_white.df994b98.svg";